module.exports = __webpack_public_path__ + "static/media/winLarge120_1.71b0b524.png";